import styled from 'styled-components';

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwitchDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
